import appConfig from 'app-config';
import { DTOShopPage } from 'src/apis/dto/DTOShopPage';
import GemProductItem from 'src/components/Shop/ProductItem/GemProductItem';
import StarterPackageItem from 'src/components/Shop/ProductItem/StarterPackageItem';
import { ProductDescription, ProductList, ProductMeta, ProductSection, ProductSectionDivider, ProductTitle } from 'src/components/Shop/style';
import type { SingleProductModule, StarterPackageModule } from 'src/types/gemLack';
import type { GemProduct } from 'src/types/Payments';
import { getGemProductSections } from 'src/utils/shop';
interface Props {
  page: DTOShopPage;
  gemProducts: GemProduct[];
  starterPackageModule?: StarterPackageModule;
  singleProductModule?: SingleProductModule;
  className?: string;
}
const ShopContentGemProducts = ({
  page,
  gemProducts,
  starterPackageModule,
  singleProductModule,
  className
}: Props) => {
  const [section] = getGemProductSections(page);
  return <ProductSection className={className} data-sentry-element="ProductSection" data-sentry-component="ShopContentGemProducts" data-sentry-source-file="GemProducts.tsx">
      {appConfig.serviceCode === 'vividi' && <ProductMeta>
          <ProductTitle>{section.title}</ProductTitle>
          <ProductDescription>{section.description}</ProductDescription>
        </ProductMeta>}
      {!!starterPackageModule && !!singleProductModule && <>
          <ProductList>
            <StarterPackageItem starterPackageModule={starterPackageModule} singleProductModule={singleProductModule} />
          </ProductList>
          <ProductSectionDivider />
        </>}
      <ProductList data-sentry-element="ProductList" data-sentry-source-file="GemProducts.tsx">
        {gemProducts.map(gemProduct => <GemProductItem gemProduct={gemProduct} key={gemProduct.productId} />)}
      </ProductList>
    </ProductSection>;
};
export default ShopContentGemProducts;